module.exports = __webpack_public_path__ + "img/selectedImg.db83f30e.png";